import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';


//the url is for aws amplify deployment recall.
Amplify.configure({ ...amplifyconfig, "oauth": {
  "domain": "buildcraft-internal.auth.ap-southeast-2.amazoncognito.com",
  "scope": [
    "openid",
    "email",
    "profile",
    "phone",
    "aws.cognito.signin.user.admin"
  ],
  "redirectSignIn": "https://buildcraft.internal.rfsons.engineering/initialize/",
  "redirectSignOut": "https://buildcraft.internal.rfsons.engineering/",
  // "redirectSignIn": "http://localhost:3000/initialize/",
  // "redirectSignOut": "http://localhost:3000/",

  "responseType": "code"
},Storage: {
  S3: {
    region: 'ap-southeast-2', // (required) - Amazon S3 bucket region
    bucket: 'projectbuildcraftstorage9390b-backend' // (required) - Amazon S3 bucket URI
  }
}});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
